// extracted by mini-css-extract-plugin
export default {"input":"ModalCadastro_input__P4xK+","linhaSalvar":"ModalCadastro_linhaSalvar__VVFle","alerta":"ModalCadastro_alerta__qjh6F"};